<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="m19 13h-6v6h-2v-6h-6v-2h6v-6h2v6h6z" />
  </svg>
</template>
